addEventListener( 'DOMContentLoaded', function () {
	const filterTabContainers = document.querySelectorAll( '.b-room-grid .c-filter-tabs' );

	filterTabContainers.forEach( ( filterTabsEl ) => {
		const parentGrid = filterTabsEl.closest( '.b-room-grid' );
		if ( ! parentGrid ) {
			return;
		}

		const cards = parentGrid.querySelectorAll( '.b-room-card[data-room-types]' );
		if ( cards.length === 0 ) {
			return;
		}

		const buttons = filterTabsEl.querySelectorAll( '.c-filter-tabs__button' );

		buttons.forEach( ( btn ) => {
			btn.addEventListener( 'click', function () {
				buttons.forEach( ( b ) => b.classList.remove( 'js-active' ) );
				btn.classList.add( 'js-active' );

				const filterSlug = btn.dataset.tab;

				cards.forEach( ( card ) => {
					if ( filterSlug === 'all' ) {
						card.classList.remove( 'js-hidden' );
						return;
					}

					const roomTypes = card.dataset.roomTypes
						? card.dataset.roomTypes.split( ',' )
						: [];

					if ( roomTypes.includes( filterSlug ) ) {
						card.classList.remove( 'js-hidden' );
					} else {
						card.classList.add( 'js-hidden' );
					}
				} );
			} );
		} );
	} );
} );
